import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#D3C3BC',
    secondary: '#BFADA5',
    accent: '#D8EBF1',
    info: '#5B5C79'
  },
  iconfont: 'mdi'
})

// Vue.use(Vuetify)

// export default new Vuetify({
//   icons: {
//     iconfont: 'md'
//   },
//   theme: {
//     dark: false
//   },
//   themes: {
//     light: {
//       primary: '#D3C3BC',
//       secondary: '#BFADA5',
//       accent: '#D8EBF1',
//       info: '#5B5C79',
//       error: '#b71c1c'
//     }
//   }
// })
